export const PROJECT_COLORS = [
  '#e8590c', '#f08c00', '#2f9e44', '#0ca678', '#1098ad', '#1c7ed6',
  '#4263eb', '#7048e8', '#ae3ec9', '#d6336c', '#e03131', '#495057',
];

export function randomProjectColor(): string {
  return PROJECT_COLORS[Math.floor(Math.random() * PROJECT_COLORS.length)]!;
}
